import React from 'react';

const HandValveHorizontalIcon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737',
  stemStartColor,
  stemMidColor,
  stemEndColor
}) => {
  const _stemStart = stemStartColor || startColor;
  const _stemMid = stemMidColor || midColor;
  const _stemEnd = stemEndColor || endColor;
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 112.5 112.5"
      className={className}
    >

<g id={`${uid}_1`}>
	<linearGradient id={`${uid}_2`} gradientUnits="userSpaceOnUse" x1="56.3628" y1="103.0498" x2="56.3628" y2="47.0254">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_2)`} d="M18.9,47.025h74.925v56.025H18.9V47.025z" />
</g>
<g id={`${uid}_3`}>
	<linearGradient id={`${uid}_4`} gradientUnits="userSpaceOnUse" x1="9.4497" y1="112.5" x2="9.4497" y2="37.5757">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_4)`} d="M0,37.575h18.9V112.5H0V37.575z" />
</g>
<g id={`${uid}_5`}>
	<linearGradient id={`${uid}_6`} gradientUnits="userSpaceOnUse" x1="103.1621" y1="112.5" x2="103.1621" y2="37.5757">
		<stop offset="0" style={{stopColor: `${startColor}`}} />
		<stop offset="0.45" style={{stopColor: `${midColor}`}} />
		<stop offset="0.55" style={{stopColor: `${midColor}`}} />
		<stop offset="0.76" style={{stopColor: `${endColor}`}} />
		<stop offset="0.77" style={{stopColor: `${endColor}`}} />
		<stop offset="1" style={{stopColor: `${startColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_6)`} d="M93.825,37.575H112.5V112.5H93.825V37.575z" />
</g>
<g id={`${uid}_7`}>
	<linearGradient id={`${uid}_8`} gradientUnits="userSpaceOnUse" x1="47.0249" y1="37.2466" x2="65.7002" y2="37.2466">
		<stop offset="0" style={{stopColor: `${_stemStart}`}} />
		<stop offset="0.45" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.55" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.76" style={{stopColor: `${_stemEnd}`}} />
		<stop offset="0.77" style={{stopColor: `${_stemEnd}`}} />
		<stop offset="1" style={{stopColor: `${_stemStart}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_8)`} d="M65.664,46.89V18.431H47.025v29.112h0c0,4.706,4.181,8.519,9.338,8.519s9.337-3.813,9.337-8.519   C65.7,47.323,65.682,47.106,65.664,46.89z" />
</g>
<g id={`${uid}_9`}>
	<linearGradient id={`${uid}_10`} gradientUnits="userSpaceOnUse" x1="18.7866" y1="11.8125" x2="93.7119" y2="11.8125">
		<stop offset="0" style={{stopColor: `${_stemStart}`}} />
		<stop offset="0.45" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.55" style={{stopColor: `${_stemMid}`}} />
		<stop offset="0.76" style={{stopColor: `${_stemEnd}`}} />
		<stop offset="0.77" style={{stopColor: `${_stemEnd}`}} />
		<stop offset="1" style={{stopColor: `${_stemStart}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_10)`} d="M18.787,4.959v6.976c0,3.717,16.772,6.731,37.462,6.731c20.69,0,37.463-3.014,37.463-6.731V4.959   H18.787z" />
	<ellipse fill={`${_stemMid}`} cx="56.249" cy="4.959" rx="37.463" ry="4.726" />
</g>
    </svg>
  );
};

export default HandValveHorizontalIcon;
